import * as React from 'react'
import { useSwipeable } from 'react-swipeable'

import { pushToEventGA4 } from '@thg-commerce/enterprise-metrics/src/data_layer/pushToDataLayer/utils'

import { CarouselReducerActions, CarouselReducerActionTypes } from '../types'

const MINIMUM_SWIPE_DISTANCE_REQUIRED = 75 // px

interface UseSwipeProps {
  dispatch: (action: CarouselReducerActions) => void
  onSwipe?: () => void
  minimumSwipeDistance?: number
}

export const useSwipe = ({ dispatch, onSwipe }: UseSwipeProps) => {
  const isSwiping = React.useRef(false)
  const [swipeOffset, setSwipeOffset] = React.useState(0)

  const swipeHandlers = useSwipeable({
    onSwipeStart: (event) => {
      if (event.dir === 'Right' || event.dir === 'Left') {
        isSwiping.current = true
      }
    },
    onSwiping: (event) => {
      if (!isSwiping.current) {
        return
      }

      event.event.preventDefault()
      setSwipeOffset(event.deltaX)
    },
    onSwiped: () => {
      setSwipeOffset(0)
    },
    onSwipedLeft: () => {
      if (!isSwiping.current) {
        return
      }
      dispatch({ type: CarouselReducerActionTypes.SlideRight } as const)
      isSwiping.current = false
      pushToEventGA4({
        event: 'product_image_transition',
        type: 'swipe',
      })
      onSwipe?.()
    },
    onSwipedRight: () => {
      if (!isSwiping.current) {
        return
      }
      dispatch({ type: CarouselReducerActionTypes.SlideLeft } as const)
      isSwiping.current = false
      pushToEventGA4({
        event: 'product_image_transition',
        type: 'swipe',
      })
      onSwipe?.()
    },
    delta: {
      left: MINIMUM_SWIPE_DISTANCE_REQUIRED,
      right: MINIMUM_SWIPE_DISTANCE_REQUIRED,
    },
    touchEventOptions: {
      passive: false,
    },
  })

  return {
    swipeHandlers,
    swipeOffset,
  }
}
